<template>
    <div class="box">
        <header class="result2-header-container">
            <div class="result2-header-top">
                <div class="return pointer no-wrap font-size16" @click="gohomefunc">
                    <i style="font-size:20px" class="el-icon-back">
                    </i>
                    <span style="color:#939395">&nbsp;返回</span>
                </div>
                <div class="result2-header-top-space"></div>
                <div class="result2-header-title">{{$route.query.examName}}</div>
            </div>
            <div class="result2-header-middle"></div>
            <div class="result2-header-footer">
                <span>
                    试卷名称: {{$route.query.examPaperNames}}
                </span>
                <span>
                    考试分类: {{$route.query.className}}
                </span>
            </div>
        </header>
        <div class="result2-search-container">
            <el-form class="xy-between p-48" inline>
                <div>
                    <el-form-item label="用户组">
                        <user-group-selector v-model="query.organLevelId" @change="loadData(true)"></user-group-selector>
                    </el-form-item>
                </div>
                <el-form-item>
                    <div class="xy-center">
                        <el-input placeholder="请输入关键字检索" v-model="query.keyword"></el-input>
                        <el-button type="primary" class="ml-10" @click="loadData(true)"><i class="el-icon-search"></i></el-button>
                    </div>
                </el-form-item>
            </el-form>
            <div class="downLoad-container">
                <el-button @click="handleExportResult(true)" type="primary"><img src="@/assets/img/exportGrades.svg" alt="exportGrades" />导出成绩</el-button>
                <el-button @click="handleExportResult(false)" type="primary"><img src="@/assets/img/exportPaper.svg" alt="exportPaper" />导出试卷</el-button>
                <el-button @click="$router.push({path:'exam-results2-records'})" type="primary"><img src="@/assets/img/notePad.svg" alt="notePad" />试卷导出记录</el-button>
            </div>
        </div>

        <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="30%"
            class="result2-dialog-container"
        >
            <div class="result2-exportDialog">
                <i style="color:#1677FF" class="el-icon-info"></i>
                <span>如未选择题干与答案，下载的试卷内容将不包含题干与答案～</span>
            </div>
            <div class="result2-exportSelect">
                <div class="selectTitle">卷面选择</div>
                <div class="selectPaper">
                    <el-checkbox v-model="paperSelect.stem">试题题干</el-checkbox>
                    <el-checkbox v-model="paperSelect.answer">试题答案</el-checkbox>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="hadnleDialogAnswer">确 定</el-button>
            <el-button @click="dialogVisible = false">取 消</el-button>
          </span>
        </el-dialog>

        <el-dialog
            :visible.sync="dialogVisibleExport"
            width="20%"
            class="result2-dialogExport-container">
            <div class="dialogExport-desc">
                <i style="color:#FFBF00;font-size: 20px" class="el-icon-warning"></i>
                <span style="margin-left:10px">您的试卷正在导出中，请24小时之后前往<router-link style="color:#1677FF" to="/manage/exam/exam-results2-records">试卷导出记录</router-link>进行下载~</span>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisibleExport = false">确 定</el-button>
                <el-button @click="dialogVisibleExport = false">取 消</el-button>
            </span>
        </el-dialog>

        <div class="ph-48" v-loading="loading">
            <el-table
                :data="list"
                :header-cell-style="{background:'#F9F9F9',color:'#32353A'}"
                border
                style="width: 100%"
                @selection-change="handleSelectChange"
                :row-key="getRowKeys"
                ref="multipleTable"
            >
                <el-table-column :reserve-selection="true" type="selection"  align="center"></el-table-column>
                <el-table-column label="学员名称"  prop="RealName" width="180" />
                <el-table-column label="用户名" prop="UserName" width="180" />
                <el-table-column label="所属分组" prop="OrganLevelName" width="180" :formatter="defaultVal"/>
                <el-table-column label="考试次数" prop="ExamNum" width="80"/>
                <el-table-column label="考试成绩" prop="ExamScore" width="80"/>
                <el-table-column label="交卷时间" prop="EndTime" :formatter="timeNoSec"/>
                <el-table-column label="答卷时长" width="100" prop="ExamTime" :formatter="secFormat"/>
                <el-table-column fixed="right" label="操作" width="100">
                    <template v-slot="scope">
                        <el-button size="mini" type="primary" @click="startView(scope.row)">答题明细</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pv-16 xy-center">
            <el-pagination
                @current-change="loadData"
                @size-change="loadData(true)"
                :current-page.sync="query.pageNo"
                :page-size.sync="query.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                hide-on-single-page
                :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import UserGroupSelector from "@/components/manager/UserGroupSelector";
import { MarkPaperList, addTaskExportWithAnswerToWord, MarkPaperListExportToExcel} from "@/api/manage";
import { cleanNoneParam } from "@/utils";
import tableFormatter from "@/mixins/tableFormatter";
export default {
    name: "correct-exam2",
    mixins: [tableFormatter],
    components: { UserGroupSelector },
    data() {
        return {
            query: {
                organLevelId: "",
                status: "",
                keyword: "",
                pageNo: 1,
                pageSize: 10
            },
            list: [],
            total: 0,
            loading: false,
            selectList: [],
            joinDetailIds: [],
            dialogVisible: false,
            dialogVisibleExport: false,
            paperSelect: {
                stem: false, // 试卷题干
                answer: false // 试卷答案
            }
        }
    },
    created() {
        this.loadData()
    },
    methods: {
        async hadnleDialogAnswer() {
            let paperMode = 0 // 0：表示none,1：试卷题干，2：试卷答案，3：题干和答案
            if (this.paperSelect.stem || this.paperSelect.answer || (this.paperSelect.stem && this.paperSelect.answer)) {
                if (this.paperSelect.stem) {
                    paperMode = 1
                }
                if (this.paperSelect.answer) {
                    paperMode = 2
                }
                if (this.paperSelect.stem && this.paperSelect.answer) {
                    paperMode = 3
                }
                let data = {
                    JoinDetailIds: this.joinDetailIds,
                    PaperMode: paperMode,
                    PaperName: this.$route.query.examName
                }
                try {
                    let res = await addTaskExportWithAnswerToWord(data)
                    this.dialogVisible = false
                    this.dialogVisibleExport = true
                    this.paperSelect = {
                        stem: false,
                        answer: false
                    }
                    this.$refs.multipleTable.clearSelection()
                } catch (error) {
                    console.error(error)
                }
            } else {
                paperMode = 0
                let data = {
                    JoinDetailIds: this.joinDetailIds,
                    PaperMode: paperMode,
                    PaperName: this.$route.query.examName
                }
                try {
                    let res = await addTaskExportWithAnswerToWord(data)
                    this.dialogVisible = false
                    this.dialogVisibleExport = true
                    this.paperSelect = {
                        stem: false,
                        answer: false
                    }
                    this.$refs.multipleTable.clearSelection()
                } catch (error) {
                    console.error(error)
                }
            }
        },
        async handleExportResult(flag) {
            this.joinDetailIds = []
            this.selectList.forEach(item => {
                this.joinDetailIds.push(item.JoinDetailId)
            })
            if (!this.selectList.length) {
                this.$message.error("请选中对应试卷或成绩在进行导出！")
            } else {
                if (flag) {
                    const loading = this.$loading({
                        lock: true,
                        text: "正在导出请稍等",
                        spinner: "el-icon-loading",
                        background: "rgba(0, 0, 0, 0.7)",
                        customClass: "result2-container"
                    });
                    let params = {
                        JoinDetailIds: this.joinDetailIds,
                        ExamId: this.$route.query.id
                    }
                    try {
                        let res = await MarkPaperListExportToExcel(params)
                        loading.close()
                        this.$refs.multipleTable.clearSelection()
                        let link = document.createElement("a")
                        link.href = res
                        link.download = "成绩统计.xlsx"
                        link.target = "_blank"
                        link.click()
                    } catch (err) {
                        console.error(err)
                    }
                } else {
                    this.dialogVisible = true
                }
            }
        },
        // 该方法是用来控制回显选中
        getRowKeys(row) {
            return row.RowIndex
        },
        // 该方法会自动保留之前页中选中的数据，前提是加入row-key和reserve-selection
        handleSelectChange(selection) {
            this.selectList = selection
        },
        gohomefunc() {
            this.$router.go(-1)
        },
        startView(row) {
            let { href } = this.$router.resolve({
                name: "gradingPaper",
                query: {
                    joinDetailId: row.JoinDetailId,
                    examId: this.$route.query.id,
                    onlyView: 1,
                    examName: row.ExamName
                }
            })
            window.open(href, "_blank")
        },
        loadData(refresh) {
            if (refresh === true) {
                this.query.pageNo = 1
            }
            this.loading = true;
            let q = cleanNoneParam(this.query)
            q.examId = this.$route.query.id
            MarkPaperList(q).then(({ data }) => {
                this.list = data.data
                this.total = data.count
            }).finally(() => {
                this.loading = false
            })
        }
    },
}
</script>

<style lang="less" scoped>
    .box{
        position: relative;
        padding: 50px 30px;
        .result2-header-container{
            .result2-header-top{
                display: flex;
                color: #2F3134;
                align-items: center;
                .return {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    .el-icon-back{
                        margin-right: 10px;
                        color: #939395;
                    }
                }
                .result2-header-top-space{
                    content:"";
                    width: 1px;
                    height: 14px;
                    margin: 0 20px;
                    background: #dcdfe6;
                }
                .result2-header-title{
                    margin: 0;
                    color: #2F3134;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-size: 18px;
                }
            }
            .result2-header-middle{
                margin: 30px 0;
                height: 1px;
                content: "";
                background-color:#E5E8EC
            }
            .result2-header-footer{
                display: flex;
                justify-content: space-between;
                span{
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #2F3134;
                }
            }
        }
        .result2-search-container{
            display: flex;
            justify-content: space-between;
            align-items: center;
            .xy-between{
                padding: 0;
                margin-top: 30px;
                display: flex;
                justify-content: start;
                .xy-center{
                    .ml-10{
                        position: relative;
                        left:-20px;
                        width: 20px;
                        border-radius: 0 4px 4px 0px ;
                        padding: 10px 20px;
                        .el-icon-search{
                            margin-left:-9px;
                            font-size: 18px;
                        }
                    }
                }
            }
            .downLoad-container{
                button{
                    background-color:transparent;
                    color: #4592ff;
                    img{
                        margin-right: 4px;
                        margin-bottom: -1px;
                    }
                }
                button:nth-child(2){
                    img{
                        margin-bottom: 0;
                    }
                }
            }
        }
        .ph-48{
            padding: 0;
        }
        .result2-dialog-container{
            .result2-exportDialog{
                background-color: rgba(237,245,255);
                font-size: 14px;
                padding: 10px;
                border-radius: 10px;
                border:1px solid #97C3FF;
                span{
                    margin-left: 10px;
                }
            }
            .result2-exportSelect{
                display: flex;
                margin-top: 20px;
                .selectTitle{
                    span{
                        color: red;
                    }
                }
                .selectPaper{
                    margin-left: 80px;
                    .el-checkbox{
                        .el-checkbox__label{
                            padding-left: 2px;
                        }
                    }
                }
            }
        }
        .result2-dialogExport-container{
            .dialogExport-desc{
                display: flex;
                justify-content: start;
                align-items: center;
                .el-icon-warning{
                    align-self: flex-start;
                }
                span{
                    font-size: 16px;
                    font-family: PingFang SC,PingFangSC-Medium;
                    color: rgba(0,0,0,0.85);
                    letter-spacing: .8px;
                }
            }
        }
    }
</style>
